import { cloneDeep } from "lodash";
import { checkChanged } from "./checkChanged";
import { ITlfActionUpdateTlf, TlfContextProps, UPDATE_TLF } from "./interface";

/**
 * Merges TLF changes and updates the baseline after saves, resets or persisted field updates.
 *
 * @param state - Current TLF context state.
 * @param action - Update action containing changed TLF fields and history flags.
 * @returns Updated TLF data, baseline and derived dirty state.
 */
export const tlf_updateTlf = (
  state: TlfContextProps,
  action: ITlfActionUpdateTlf,
): TlfContextProps => {
  if (!state.tlfData) {
    throw new Error(`tlfContextReducer: ${UPDATE_TLF}: TLF data not set`);
  }

  const newState = { ...state };
  const newTlfData = {
    ...state.tlfData,
    ...action.tlfData,
  };
  newState.tlfData = newTlfData;

  if (action.reset) {
    newState.savedTlfData = cloneDeep(newTlfData);
    newState.showModalWindow = "";
    newState.forcePushToParent = true;
  } else if (action.newSavePoint) {
    newState.savedTlfData = cloneDeep(newTlfData);
    newState.showModalWindow = "";
    newState.forcePushToParent = true;
  } else if (action.doNotAddUndo) {
    newState.savedTlfData = cloneDeep({
      ...(state.savedTlfData ?? state.tlfData),
      ...action.tlfData,
    });
    newState.forcePushToParent = true;
  }
  checkChanged(newState);

  return newState;
};
